import React from 'react';
import { useFetch } from 'src/hooks/useFetch';
import { Modal } from '..';
import {
  TextField,
  Stack,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from '@mui/material';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { toast } from 'react-toastify';
import { useLocation } from 'react-router';

const EditarUsuario = (props) => {
  let location = useLocation();

  const { open, close, afterConfirm } = props;
  const { fetch } = useFetch();

  const dataUser = props.data;
  const formik = useFormik({
    /* enableReinitialize: true, */
    initialValues: {
      ...dataUser /*  telefono: dataUser?.telefono?.slice(1) */,
    },

    validationSchema: Yup.object({
      rut: Yup.string().matches(
        /^\d{7,8}-[0-9k]$/i,
        'Debe tener 10 caracteres, 8 numeros, seguido por un guiónn una letra o un número ',
      ),
      nombre: Yup.string()
        .matches(
          /^[a-záéíóúü]+( [a-záéíóúü]+)*$/i,
          'Debe contener solo letras, sin números ni caracteres especiales y no debe comenzar ni terminar con espacios vacíos.',
        )
        .required('El nombre es obligatorio'),
      email: Yup.string()
        .email('No es un email válido')
        .required('El email es obligatorio'),
      /*  .required('El email es obligatorio'), */
      direccion: Yup.string()
        .matches(
          /^[a-záéíóúü0-9.]+( [a-záéíóúü0-9\-_#\/,.]+)*$/i,
          "Debe tener letras, numeros o lo siguientes simbolos  '.' '-' ',' '_' '#' '/'  y no debe comenzar ni terminar con espacios vacíos",
        )
        .required('La dirección es obligatoria'),
      username: Yup.string(),
      /*   telefono: Yup.string()
        .matches(/^56[\d]{9}/, 'No es el formato correcto')
        .required('El teléfono es obligatorio'), */
      password: dataUser
        ? Yup.string()
        : Yup.string()
            .required('La contraseña es obligatoria')
            .oneOf(
              [Yup.ref('repeatPassword')],
              'Las contraseñas no son iguales',
            ),
      repeatPassword: dataUser
        ? Yup.string()
        : Yup.string()
            .required('La contraseña es obligatoria')
            .oneOf([Yup.ref('password')], 'Las contraseñas no son iguales'),
    }),
    onSubmit: async (values, { resetForm }) => {
      try {
        Reflect.deleteProperty(values, 'id');
        Reflect.deleteProperty(values, 'estado');
        Reflect.deleteProperty(values, 'rut');
        Reflect.deleteProperty(values, 'telefono');
        Reflect.deleteProperty(values, 'username');
        Reflect.deleteProperty(values, 'email');
        Reflect.deleteProperty(values, 'mfa');

        let res = await fetch(`/usuarios/${props.data.id}`, {
          method: 'PATCH',
          data: { ...values },
        });

        close();
        if (res.statusText === 'OK') {
          if (location.pathname.includes('perfil')) {
            afterConfirm(res.data);
          } else {
            afterConfirm();
          }
        }
        toast.success('Usuario creado/modificado con exito');
      } catch (error) {
        toast.error('No se ha podido editar al usuario');

        console.error(error);
      }
    },
  });

  const handleSelectChange = (e) => {
    formik.setFieldValue('tipo', e.target.value);
  };
  const onCloseModal = React.useCallback(() => {
    close();
  }, [close]);
  const confirmHandler = async () => {
    formik.handleSubmit();
  };

  return (
    <Modal
      title={'Editar Usuario'}
      content={
        <>
          <form
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              height: '100%',
              marginTop: '1rem',
            }}
            onSubmit={formik.handleSubmit}
          >
            <Stack
              spacing={3}
              justifyContent="center"
              alignItems="center"
              sx={{ height: '100%' }}
            >
              <Stack direction="row" spacing={2}>
                <TextField
                  focused
                  size="small"
                  fullWidth
                  id="rut"
                  name="rut"
                  label="RUT"
                  value={formik.values.rut}
                  onChange={formik.handleChange}
                  color="grey"
                  disabled={dataUser ? true : false}
                  error={formik.touched.rut && Boolean(formik.errors.rut)}
                  helperText={formik.touched.rut && formik.errors.rut}
                />

                <TextField
                  size="small"
                  fullWidth
                  id="nombre"
                  name="nombre"
                  label="Nombre Completo"
                  color="grey"
                  focused
                  value={formik.values.nombre}
                  onChange={formik.handleChange}
                  error={formik.touched.nombre && Boolean(formik.errors.nombre)}
                  helperText={formik.touched.nombre && formik.errors.nombre}
                />
              </Stack>
              <Stack direction="row" spacing={2}>
                <TextField
                  size="small"
                  fullWidth
                  id="username"
                  name="username"
                  label="UserName"
                  color="grey"
                  focused
                  disabled={dataUser ? true : false}
                  value={formik.values.username ? formik.values.username : ''}
                  onChange={formik.handleChange}
                  error={
                    formik.touched.username && Boolean(formik.errors.username)
                  }
                  helperText={formik.touched.username && formik.errors.username}
                />
                <TextField
                  size="small"
                  fullWidth
                  id="direccion"
                  name="direccion"
                  label="Dirección"
                  color="grey"
                  value={formik.values.direccion}
                  onChange={formik.handleChange}
                  error={
                    formik.touched.direccion && Boolean(formik.errors.direccion)
                  }
                  helperText={
                    formik.touched.direccion && formik.errors.direccion
                  }
                  focused
                />
              </Stack>

              <Stack direction="row" spacing={2} sx={{ width: '100%' }}>
                <TextField
                  size="small"
                  id="email"
                  disabled={true}
                  name="email"
                  label="Email"
                  color="grey"
                  focused
                  fullWidth
                  value={formik.values.email}
                  onChange={formik.handleChange}
                  error={formik.touched.email && Boolean(formik.errors.email)}
                  helperText={formik.touched.email && formik.errors.email}
                />
                <TextField
                  size="small"
                  fullWidth
                  id="telefono"
                  name="telefono"
                  label="Teléfono"
                  color="grey"
                  focused
                  disabled={dataUser ? true : false}
                  value={formik.values.telefono ? formik.values.telefono : ''}
                  onChange={formik.handleChange}
                  error={
                    formik.touched.telefono && Boolean(formik.errors.telefono)
                  }
                  helperText={formik.touched.telefono && formik.errors.telefono}
                />
              </Stack>
              {!location.pathname.includes('perfil') ? (
                <Stack direction="row" spacing={2} sx={{ width: '100%' }}>
                  <FormControl fullWidth focused color="grey">
                    <InputLabel id="login-type-select">
                      Tipo de Usuario
                    </InputLabel>
                    <Select
                      fullWidth
                      size="small"
                      labelId="login-type-select"
                      label="Tipo de Usuario"
                      name="tipo"
                      value={formik.values.tipo}
                      onChange={handleSelectChange}
                    >
                      <MenuItem value={1}>Comun</MenuItem>
                      <MenuItem value={2}>Administrador</MenuItem>
                    </Select>
                  </FormControl>
                </Stack>
              ) : null}

              {/*  <FormControl sx={{ width: '100%' }}>
                <Stack
                  sx={{ width: '100%', height: '100%' }}
                  direction="column"
                  justifyContent={'flex-start'}
                >
                  <PhoneField name="telefono" formik={formik} />

                  {formik.touched.telefono &&
                  Boolean(formik.errors.telefono) ? (
                    <FormHelperText sx={{ color: '#FF4842' }}>
                      {formik.errors.telefono}
                    </FormHelperText>
                  ) : null}
                </Stack>
              </FormControl> */}
            </Stack>
          </form>
        </>
      }
      open={open}
      close={onCloseModal}
      showConfirmButton={true}
      onConfirm={confirmHandler}
    />
  );
};

export default EditarUsuario;
